import { useState } from 'react';
import { IconUp, IconDown } from '@ui/src';
import { NewApplicationStepStatus } from '../../../../hoc/new-application/types';
import { StepItemTypes } from './types';

import cn from './styles.module.css';

const StepItem = ({ status, title, children, id, zIndex }: StepItemTypes) => {
  const [collapsed, setCollapsed] = useState(true);

  return (
    <div
      className={cn.stepItem}
      id={id}
      style={{
        position: 'relative',
        zIndex,
      }}
    >
      <button
        type="button"
        className={cn.stepItemTop}
        onClick={() => setCollapsed(!collapsed)}
        tabIndex={-1}
      >
        <div
          className={`${cn.stepItemCirlce} ${
            status === NewApplicationStepStatus.COMPLETED
              ? cn.stepItemCircleCompleted
              : ''
          } ${
            status === NewApplicationStepStatus.IN_PROGRESS
              ? cn.stepItemCircleInprogress
              : ''
          }`}
        />
        <div
          className={`${cn.stepItemTopTitle} ${
            status === NewApplicationStepStatus.AWAITING
              ? cn.stepItemTitleAwaiting
              : ''
          }`}
        >
          {title}
        </div>
        {!collapsed ? (
          <IconDown
            className={`${cn.stepItemTopIcon} ${
              status === NewApplicationStepStatus.AWAITING
                ? cn.stepItemIconAwaiting
                : ''
            }`}
          />
        ) : (
          <IconUp
            className={`${cn.stepItemTopIcon} ${
              status === NewApplicationStepStatus.AWAITING
                ? cn.stepItemIconAwaiting
                : ''
            }`}
          />
        )}
      </button>
      {collapsed && <div className={cn.stepItemContent}>{children}</div>}
    </div>
  );
};

export default StepItem;
